import { useId } from 'react';

export default function BinaryOrbVisual({ lights, size, containerRef }) {
  const id = useId().replace(/:/g, '');
  return (
    <svg ref={containerRef} width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true" className="shrink-0">
      <defs>
        <clipPath id={`${id}-clip`}><circle cx="50%" cy="50%" r="47%" /></clipPath>
        <radialGradient id={`${id}-base`} cx="40%" cy="40%" r="60%">
          <stop offset="0%" stopColor="#1e293b" /><stop offset="50%" stopColor="#0f172a" /><stop offset="100%" stopColor="#000000" />
        </radialGradient>
        <radialGradient id={`${id}-glow`}>
          <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.15" /><stop offset="70%" stopColor="#3b82f6" stopOpacity="0.08" /><stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
        </radialGradient>
        <filter id={`${id}-soft`}><feGaussianBlur stdDeviation="2" /></filter>
        <filter id={`${id}-light`}><feGaussianBlur stdDeviation="2.5" /></filter>
        <filter id={`${id}-orb`}><feGaussianBlur stdDeviation="1.5" /></filter>
      </defs>
      <circle cx="50%" cy="50%" r="45%" fill={`url(#${id}-base)`} />
      <circle cx="50%" cy="50%" r="44%" fill={`url(#${id}-glow)`} />
      <g clipPath={`url(#${id}-clip)`} filter={`url(#${id}-orb)`}>
        {lights.map(light => <circle key={light.id} cx={`${light.x}%`} cy={`${light.y}%`} r={light.radius} fill={light.color} opacity={light.opacity} filter={`url(#${id}-light)`} />)}
      </g>
      <circle cx="50%" cy="50%" r="47%" fill={`url(#${id}-glow)`} filter={`url(#${id}-soft)`} opacity="0.25" clipPath={`url(#${id}-clip)`} />
      <circle cx="50%" cy="50%" r="45%" fill="none" stroke="#3b82f6" strokeOpacity="0.25" strokeWidth={size * 0.012} />
      <ellipse cx="38%" cy="32%" rx="10%" ry="8%" fill="#ffffff" opacity="0.12" />
    </svg>
  );
}